<ion-text color="dark" *ngIf="dateKeySeparator">
  <h6 class="ion-margin-vertical color-dark-gray">
    {{ dateKeySeparator }}
  </h6>
</ion-text>

<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content" (click)="onClickBooking(row)">
    <ion-col size="2">
      <img
        *ngIf="row.bookingSpaces[0].space.image"
        class="parking-view__image"
        (click)="
          onImagePreview($event, row.bookingSpaces[0].space.image.filePath)
        "
        [src]="
          row.bookingSpaces[0].space.image.thumbnail
            ? row.bookingSpaces[0].space.image.thumbnail
            : row.bookingSpaces[0].space.image.filePath
        "
      />

      <img
        *ngIf="!row.bookingSpaces[0].space.image"
        class="parking-view__image"
        src="../../../assets/icons/room-plug.svg"
      />
    </ion-col>

    <ion-col size="2"> {{ row.bookingSpaces[0].space.name }} </ion-col>

    <ion-col size="2">
      {{ row.startTime | dateSti }} -
      {{ row.endTime | dateSti: "onlyHour" }}
    </ion-col>

    <ion-col size="3">
      {{ row.title }}
    </ion-col>
    <ion-col size="3">
      <app-status
        [color]="
          dictionaryServ.getDictionaryKeyColor(
            dictionaryServ.bookingStatusValues,
            row.status
          )
        "
        [name]="bookingServ.setStatusName(row.status)"
      ></app-status>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  (click)="onClickBooking(row)"
>
  <ion-card-content class="booking-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col class="space-between">
          <app-status
            [color]="
              dictionaryServ.getDictionaryKeyColor(
                dictionaryServ.bookingStatusValues,
                row.status
              )
            "
            [name]="bookingServ.setStatusName(row.status)"
          ></app-status>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-header class="header-padding__top">
    <ion-card-title
      class="display-flex ion-align-items-center ion-justify-content-between"
    >
      <span class="word-break-always">
        {{ row.title }}
      </span>

      <ion-button
        *ngIf="row.bookingSpaces[0].space.image"
        (click)="
          onImagePreview($event, row.bookingSpaces[0].space.image.filePath)
        "
        shape="round"
        fill="clear"
      >
        <!-- size="small" -->
        <img
          *ngIf="row.bookingSpaces[0].space.image"
          class="booking-view__image"
          [src]="
            row.bookingSpaces[0].space.image.thumbnail
              ? row.bookingSpaces[0].space.image.thumbnail
              : row.bookingSpaces[0].space.image.filePath
          "
        />
      </ion-button>
    </ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="no-padding-grid booking-mobile">
      <ion-row>
        <ion-col>
          <ion-icon mobile src="assets/icons/point.svg"></ion-icon>
          <ion-text mobile class="inv-info">{{
            row.bookingSpaces[0].space.name
          }}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col *ngIf="sameDay(row.startTime, row.endTime)">
          <ion-icon mobile src="assets/icons/clock.svg"></ion-icon>
          <ion-text class="inv-info"
            >{{ row.startTime | dateSti }} -
            {{ row.endTime | dateSti: "onlyHour" }}</ion-text
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
